'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'rv';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f7be';
var svgPathData = 'M216 32l0 8c0 4.4-3.6 8-8 8L104 48c-48.6 0-88 39.4-88 88l0 177.5c0 12.7 4.3 25.1 12.3 35L72 403.2c13.9-30.2 44.5-51.2 80-51.2 45.9 0 83.6 35.1 87.6 80l112.4 0 0-280c0-4.4 3.6-8 8-8l200 0 0-24c0-39.8-32.2-72-72-72L368 48c-4.4 0-8-3.6-8-8l0-8c0-8.8-7.2-16-16-16L232 16c-8.8 0-16 7.2-16 16zM440 528c-45.9 0-83.6-35.1-87.6-80l-112.7 0c-4 44.9-41.7 80-87.6 80-48.6 0-88-39.4-88-88 0-6.4 .7-12.7 2-18.7l-.2-.3-50-62.5C5.6 345.8 0 329.9 0 313.5L0 136C0 78.6 46.6 32 104 32l96 0c0-17.7 14.3-32 32-32L344 0c17.7 0 32 14.3 32 32l112 0c48.6 0 88 39.4 88 88l0 32c0 4.4-3.6 8-8 8l-200 0 0 32 104 0c17.6 0 34.2 8.3 44.8 22.4l48 64c7.3 9.7 11.2 21.5 11.2 33.6l0 80c0 28.3-21 51.7-48.3 55.5-3.8 45.1-41.6 80.5-87.7 80.5zm87.6-96.7C546 427.7 560 411.5 560 392l0-80c0-2.7-.3-5.4-.8-8l-191.2 0 0 85.4c15.9-22.6 42.2-37.4 72-37.4 45.7 0 83.2 34.8 87.6 79.3zM472 208l-104 0 0 80 184 0-48-64c-7.6-10.1-19.4-16-32-16zM152 512a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm288 0a72 72 0 1 0 0-144 72 72 0 1 0 0 144zM128 128l128 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm-16 32l0 64c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRv = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;